import React from 'react';
import { motion } from 'framer-motion';
import TeamCalendar from '../../components/calendar/TeamCalendar';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCalendar } = FiIcons;

const AdminCalendar = () => {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">ปฏิทินระบบ</h1>
        <p className="text-gray-600">จัดการตารางนัดหมายและกิจกรรมทั้งหมดในระบบ</p>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <TeamCalendar />
      </motion.div>
    </div>
  );
};

export default AdminCalendar;
